export default __webpack_public_path__ + "static/media/welcome-analytics.88ce50b1.png";